import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import TruncateItemWithTooltip from 'helpers/truncateItemWithTooltip';
import { Theme } from 'styles/ThemeTyping';
import * as Types from 'pages/RolesAndPermissions/typings';

import MenuList from '@material-ui/core/MenuList';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';

interface Props {
  input: string;
  options: Array<Types.FieldValue>;
  placeholderText?: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onSelect: (value: string) => void;
}

function FreeformAndSearchInput({ input, options, placeholderText, onChange, onSelect }: Props) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div>
        <div className={classes.row}>
          <TextField
            placeholder={placeholderText || 'Type to search'}
            onChange={onChange}
            fullWidth
            value={input}
            onKeyDown={e => {
              if (e.key === 'Enter') {
                onSelect(input);
              }
            }}
          />
        </div>

        <MenuList className={classes.menu}>
          {options.map((option, i) => (
            <MenuItem onClick={() => onSelect(option.value)} key={`${option.value}-${i}`}>
              <TruncateItemWithTooltip option={option.title} />
            </MenuItem>
          ))}
        </MenuList>
      </div>
    </div>
  );
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    maxWidth: 377,
    marginBottom: theme.spacing(),
  },
  menu: {
    maxHeight: 250,
    overflowY: 'auto',
  },
  row: {
    height: 32,
    paddingLeft: theme.spacing(),
  },
}));

export default FreeformAndSearchInput;
